import { useFormikContext } from 'formik'
import { ReactElement } from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { Column } from 'components/v2/Column'
import FormLayout from 'components/v2/FormLayout'
import Heading from 'components/v2/Heading'
import { Input } from 'components/Input'
import { Row } from 'components/v2/Row'
import { INewPartnerStep2 } from 'features/Partners/types'

import { InputNumber } from 'components/InputNumber'
import { CLABE_MASK } from 'utils/masks'
import { Select } from 'components/v2/Select'
import { GTBusinessPartnerBankPaymentType } from 'gql/types.generated'

const messages = defineMessages({
  bankNamePlaceholder: {
    id: 'partners.form.bankName.placeholder',
    defaultMessage: 'Enter a bank name'
  },
  clabeNumberPlaceholder: {
    id: 'partners.form.clabeNumber.placeholder',
    defaultMessage: 'Enter CLABE'
  },
  emailPlaceholder: {
    id: 'partners.form.email.placeholder',
    defaultMessage: 'Enter email'
  },
  selectPaymentTypePlaceholder: {
    id: 'partners.form.selectPaymentType.placeholder',
    defaultMessage: 'Select payment type'
  },
  bankCoverLinkPlaceholder: {
    id: 'partners.form.bankCoverLink.placeholder',
    defaultMessage: 'Enter bank cover Link'
  }
})
export const PartnerBankDataCard = (): ReactElement => {
  const intl = useIntl()
  const { values, handleChange, handleBlur, touched, errors, setFieldValue } = useFormikContext<INewPartnerStep2>()

  return (
    <FormLayout.Card small>
      <Heading.H4>
        <FormattedMessage id="partnerData.bankData.title" defaultMessage="Bank Data" />
      </Heading.H4>
      <Row>
        <Column>
          <InputNumber
            id="bankData.clabeNumber"
            mask={CLABE_MASK}
            value={values.bankData.clabeNumber}
            onChange={(value: string): void => {
              setFieldValue('bankData.clabeNumber', value)
            }}
            onBlur={handleBlur}
            placeholder={intl.formatMessage(messages.clabeNumberPlaceholder)}
            touched={touched.bankData?.clabeNumber}
            errors={errors.bankData?.clabeNumber}
            label={<FormattedMessage id="companyClient.clabeNumber.label" defaultMessage="CLABE" />}
          />
        </Column>
        <Column>
          <Input
            id="bankData.bankName"
            value={values.bankData.bankName}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={intl.formatMessage(messages.bankNamePlaceholder)}
            touched={touched.bankData?.bankName}
            errors={errors.bankData?.bankName}
            label={<FormattedMessage id="partnerData.bankData.bankName.label" defaultMessage="Partner Bank Name" />}
          />
        </Column>
      </Row>
      <Row>
        <Column width="50%">
          <Input
            id="bankData.email"
            value={values.bankData.email}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={intl.formatMessage(messages.emailPlaceholder)}
            touched={touched.bankData?.email}
            errors={errors.bankData?.email}
            label={<FormattedMessage id="partnerData.bankData.email.label" defaultMessage="Email" />}
          />
        </Column>
        <Column width="50%">
          <Input
            id="bankData.bankCoverLink"
            value={values.bankData.bankCoverLink}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={intl.formatMessage(messages.bankCoverLinkPlaceholder)}
            touched={touched.bankData?.bankCoverLink}
            errors={errors.bankData?.bankCoverLink}
            label={<FormattedMessage id="partnerData.bankData.bankCoverLink.label" defaultMessage="Bank Cover Link" />}
          />
        </Column>
      </Row>
      <Row>
        <Column width="50%">
          <Select
            id="type"
            value={values.bankData.paymentType}
            onChange={(e): void => {
              setFieldValue('bankData.paymentType', e.target.value)
            }}
            touched={Boolean(touched.bankData?.paymentType)}
            errors={errors.bankData?.paymentType}
            label={<FormattedMessage id="dictionary.type" defaultMessage="Type" />}
          >
            <option value="">{intl.formatMessage(messages.selectPaymentTypePlaceholder)}</option>
            <option value={GTBusinessPartnerBankPaymentType.TransferWithinBank}>
              <FormattedMessage
                id="partnerData.bankData.paymentType.transfer"
                defaultMessage="Transferencia al mismo banco"
              />
            </option>
            <option value={GTBusinessPartnerBankPaymentType.Spei}>
              <FormattedMessage id="partnerData.bankData.paymentType.spei" defaultMessage="SPEI" />
            </option>
            <option value={GTBusinessPartnerBankPaymentType.InterbankTransfer}>
              <FormattedMessage
                id="partnerData.bankData.paymentType.interbankTransfer"
                defaultMessage="Transferencia interbancaria"
              />
            </option>
          </Select>
        </Column>
      </Row>
    </FormLayout.Card>
  )
}
